<template>
  <TheTemplateM class="p-the-page-m12">
    <template #heading>秘密の質問の変更</template>

    <template #body>
      <div class="p-the-page-m12__form c-form-inner">
        <ValidationObserver v-slot="ObserverProps" slim>
          <form
            ref="form"
            action="/m01/m12_complete.html"
            method="post"
            @submit.prevent="submit(ObserverProps)"
          >
            <div class="p-form-group">
              <FormLabel for="secretQuestion" :required="true"
                >秘密の質問</FormLabel
              >
              <ValidationProvider
                v-slot="ProviderProps"
                name="秘密の質問"
                rules="required"
              >
                <InputSelect
                  id="secretQuestion"
                  v-model="secretQuestion"
                  name="secretQuestion"
                  :error="ProviderProps.errors[0]"
                  :options="secretQuestionOptions"
                ></InputSelect>
                <ValidationErrorText v-show="ProviderProps.errors[0]">
                  {{ ProviderProps.errors[0] }}
                </ValidationErrorText>
              </ValidationProvider>
            </div>

            <div class="p-form-group">
              <FormLabel for="secretAnswer" :required="true"
                >秘密の質問の答え</FormLabel
              >
              <ValidationProvider
                v-slot="ProviderProps"
                name="秘密の質問の答え"
                rules="required|max:100"
              >
                <InputText
                  id="secretAnswer"
                  v-model="secretAnswer"
                  type="text"
                  name="secretAnswer"
                  placeholder="質問の答え"
                  :error="ProviderProps.errors[0]"
                ></InputText>
                <ValidationErrorText v-show="ProviderProps.errors[0]">
                  {{ ProviderProps.errors[0] }}
                </ValidationErrorText>
              </ValidationProvider>
            </div>

            <div class="p-form-button-group">
              <div class="p-form-button-group__vertical">
                <ButtonMain
                  type="submit"
                  :disabled="ObserverProps.invalid"
                  @click-button="submitAnswer"
                  >変更</ButtonMain
                >
              </div>
              <div class="p-form-button-group__vertical">
                <ButtonMain :tag="'a'" href="/my-page/" :kind="'cancel'"
                  >キャンセル</ButtonMain
                >
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </template>
  </TheTemplateM>
</template>

<script lang="ts">
import TheTemplateM from "@/general/components/templates/TheTemplateM.vue";
import InputText from "@/common/components/atoms/InputText.vue";
import InputSelect from "@/common/components/atoms/InputSelect.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import FormLabel from "@/common/components/organisms/FormLabel.vue";
import ValidationErrorText from "@/common/components/atoms/ValidationErrorText.vue";
import { defineRule, validate, configure, FieldContext } from "vee-validate";
import { required, max } from "@vee-validate/rules";
import { Options, Vue } from "vue-class-component";
import {
  putPasswordReminder,
  getPasswordReminder,
  getSecretQuestions
} from "@/general/store/api";
import commons from "@/common/store/modules/commons";
import AuthStorage from "@/general/utils/auth";

defineRule("required", required);
defineRule("max", max);

configure({
  generateMessage: (ctx: any) => {
    const messages: Record<string, string> = {
      required: `${ctx.field}を入力してください。`,
      max: `${ctx.field}は${ctx.rule?.params?.[0]}文字以内を入力してください。`
    };
    return messages[ctx.rule.name] || `${ctx.field}の入力が不正です。`;
  }
});

@Options({
  props: {
    id: { type: Number, default: 1 }
  },
  components: {
    TheTemplateM,
    InputText,
    InputSelect,
    ButtonMain,
    FormLabel,
    ValidationErrorText
  }
})
export default class SecrateQuestion extends Vue {
  id!: number;
  formData: any = [];

  secretQuestion!: any;
  secretQuestionOptions: any = [];
  secretAnswer = "";

  breadcrumb = [
    {
      text: "",
      url: "/home",
      pageType: "home"
    },
    {
      text: "マイページ",
      url: "/my-page",
      pageType: "lower"
    },
    {
      text: "秘密の質問変更",
      url: "",
      pageType: "lower"
    }
  ];

  submit(ObserverProps: any) {
    ObserverProps.passes(() => {
      this.$refs.form as Vue & { submit: () => any };
    });
  }

  get passwordReminder() {
    return {
      id: 1,
      user: 1,
      question: this.secretQuestion,
      answer: this.secretAnswer
    };
  }

  mounted() {
    AuthStorage.checkLogin();
  }

  async created() {
    await commons.setOrgPageSpecificDataFromLocalStorage();
    const response = await getPasswordReminder(this.id);
    this.formData = response;
    this.secretQuestion = this.formData.question;
    this.secretAnswer = this.formData.answer;

    const secretQuestions = await getSecretQuestions();
    this.secretQuestionOptions = secretQuestions.results?.map((res) => {
      return { value: res.id, label: res.question };
    });
    this.secretQuestionOptions.unshift({ value: "", label: "" });
    await commons.getBreadcrumb(this.breadcrumb);
  }
  async submitAnswer() {
    const response = await putPasswordReminder(this.id, this.passwordReminder);
    this.formData = response;
    window.location.href = "/my-page/secretQuestionUpdated.html";
  }
}
</script>

<style lang="scss" scoped>
.p-the-page-m12 {
}
</style>
